const tabHeadingBlock = document.querySelector('.featured_collection_heading_block');
const tabContentBlock = document.querySelectorAll('.featured_collection_new');
const tabHeading= document.querySelectorAll('.featured_collection_heading');

tabHeadingBlock.addEventListener('click', function(e){
  const clicked = e.target.closest('.featured_collection_heading');
  if (!clicked) return;
  tabHeading.forEach( th => th.classList.remove('featured_collection_heading--active') );
  clicked.classList.add('featured_collection_heading--active');
  tabContentBlock.forEach( tc => tc.classList.remove('featured_collection_content--active') );
  document.querySelector(`.featured_collection_content--${clicked.dataset.tab}`).classList.add('featured_collection_content--active');
});